import * as types from './mutation-type'
import api from "@/modules/api";
import { merge } from 'lodash'
import moment from 'moment'
import { MOMENT_FORMAT_DATE } from '@/helpers'

const actions = {
  async postCreditCard({
    commit,
    rootState
  }, { stripeToken, companyId }) {
    try {
      commit(types.POST_CREDIT_CARD_BEGIN)
      const {
        data:{ message }
      } = await api.billing.createBillingRequest(companyId, stripeToken.id)
      commit(types.POST_CREDIT_CARD_SUCCESS,{ message, stripeToken, rootState })
    } catch (error) {
      commit(types.POST_CREDIT_CARD_ERROR, error)
    }
  },

  async postBillingInvoice({ commit ,rootState ,dispatch }, { companyId } ) {
    try {
      commit(types.POST_BILLING_INVOICE_BEGIN)
      const {
        data:{ message ,company }
      } = await api.billing.payBillingInvoice(companyId)
      commit(types.POST_BILLING_INVOICE_SUCCESS,{ message,company, rootState })
      let billingAnniversaryDate = company.billing_anniversary_date
      billingAnniversaryDate = moment(billingAnniversaryDate,MOMENT_FORMAT_DATE).add(1,'month').format(MOMENT_FORMAT_DATE)      
      //mocking billingAnniversary date as it is updated only through webhooks
      const merged  = merge(company,{ 'billing_anniversary_date' : billingAnniversaryDate,isActive : 1 })
      dispatch('app/mergeObject',{ key : 'Company', object : merged },{ root : true })
    } catch (error) {
      commit(types.POST_BILLING_INVOICE_ERROR, error)
    }
  },

  async getBillingInvoice({ commit }, { companyId }) {
    try {
      commit(types.GET_BILLING_INVOICE_BEGIN);
      const {
        data: {
          data
        }
      } = await api.billing.getBillingInvoice(companyId)

      commit(types.GET_BILLING_INVOICE_SUCCESS, data);
    } catch (e) {
      commit(types.GET_BILLING_INVOICE_ERROR, e);
    }
  },
  
  async updateBillingPackage({ commit ,dispatch }, { companyId, data }) {
    try {
      commit(types.POST_BILLING_PACKAGE_BEGIN)
      const  response  = await api.company.update(companyId, data)
      dispatch('app/mergeObject',{ key : 'Company',object : response.data },{ root : true })
      commit(types.POST_BILLING_PACKAGE_SUCCESS);
    } catch (e) {
      commit(types.POST_BILLING_PACKAGE_ERROR, e);
    }
  },

  async getNewBillingCount({ commit }, { companyId,billingType }) {
    commit(types.GET_NEWBILLING_COUNT_BEGIN);
    try {
      const {
        data
      } = await api.billing.getNewBillingCount(companyId,billingType)
      commit(types.GET_NEWBILLING_COUNT_SUCCESS, data)
     
    } catch (e) {
      commit(types.GET_NEWBILLING_COUNT_ERROR, e);
    }
  },
  async cancelPackageSubscription({ commit,dispatch },{ companyId , billingCancellationDate }) {
    try {
      commit(types.CANCEL_PACKAGE_BEGIN)
      const { data:company } = await api.company.update(companyId, { billingCancellationDate })
      dispatch('app/mergeObject',{ key : 'Company',object : company },{ root : true })
      commit(types.CANCEL_PACKAGE_SUCCESS, company);
    } catch (e) {
      commit(types.CANCEL_PACKAGE_ERROR, e);
    }
  },

  async reactivatePackageSubscription({ commit,dispatch },{ companyId , data }) {
    try {
      commit(types.REACTIVATE_PACKAGE_BEGIN)
      const response = await api.company.update(companyId,  data )
      dispatch('app/mergeObject',{ key : 'Company',object : response.data },{ root : true })
      commit(types.REACTIVATE_PACKAGE_SUCCESS);
    } catch (e) {
      commit(types.REACTIVATE_PACKAGE_ERROR, e);
    }
  },

  toggleReactivateSubscriptionPopup({ commit }, isShow){
    commit(types.TOGGLE_REACTIVATE_SUBSCRIPTION_POPUP, isShow)
  },

  selectBillingType({ commit }, packageType){
    commit(types.GET_BILLING_TYPE, packageType)
  },
  
  async removePackageSubscription({ commit,dispatch },{ companyId }  ) {
    try {
      commit(types.REMOVE_PACKAGE_SUBSCRIPTION_BEGIN)
      const response = await api.billing.removeSubscriptionPackage(companyId)
      dispatch('app/mergeObject',{ key : 'Company',object : response.data.company },{ root : true })
      commit(types.REMOVE_PACKAGE_SUBSCRIPTION_SUCCESS);
    } catch (e) {
      commit(types.REMOVE_PACKAGE_SUBSCRIPTION_ERROR, e);
    }
  }
}


export default actions

